// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"styles_modal-body_2OGF1Hzsq8wYZxKBguy-9m","modalBody":"styles_modal-body_2OGF1Hzsq8wYZxKBguy-9m"};